// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-share-tree{height:fit-content;min-height:10em;max-height:20em;overflow:auto}.cvat-empty-share-tree>.ant-typography{margin-top:10px}\n", ""]);
// Exports
module.exports = exports;
